import localstorage from 'src/helper/localstorage'
let ENV = process.env.APP_ENV || process.env.NODE_ENV
const EnvConfig = {
  development: {
    host: `http://127.0.0.1:8082`,
    uploadHost: `http://127.0.0.1:8082/dash/utils/upload`
  },
  test: {
    host: `https://api-test.superforest.vip`,
    uploadHost: `https://api-test.superforest.vip/dash/utils/upload`
  },
  production: {
    host: `https://api.superforest.vip`,
    uploadHost: `https://api.superforest.vip/dash/utils/upload`
  }
}
let config = {
  route: {
    default: { module: `dashboard`, controller: `reservation`, action: `index` },
    whiteList: ['/oauth/login/index']
  },
}
config = Object.assign(config, EnvConfig[ENV])
const accesstoken = localstorage.get('userToken')
config.accesstoken =`Bearer ${accesstoken}`
export default config



// WEBPACK FOOTER //
// ./core/config.js